import {isNullOrUndefined, isTrimmedStringEmpty} from "../commonUtilities";

export function isArray(value: unknown): value is unknown[] {
	return Array.isArray(value);
}

export function isString(value: unknown): value is string {
	return typeof value === "string";
}

export function isBoolean(value: unknown): value is boolean {
	return typeof value === "boolean";
}

export function isNumber(value: unknown): boolean {
	return !isNullOrUndefined(value) && !isNaN(value as number) && !isTrimmedStringEmpty(String(value));
}